import LocationOn from '@material-ui/icons/LocationOn';
import withStyles from '@material-ui/styles/withStyles';

const WellMapMarker = ({ classes, wellboreId }) => {
  return <LocationOn data-marker-id={wellboreId} className={classes.root} />;
};

const styles = (theme) => ({
  root: {
    fontSize: theme.typography.h4.fontSize,
    color: theme.palette.secondary.mainLight,
  },
  zoomedIcon: {
    transition: 'transform 0.2s ease-in-out',
    transform: 'scale(1.5)',
  },
});

export default withStyles(styles)(WellMapMarker);
